import React from "react";
import ReactTooltip from "react-tooltip";

import { Factor, models } from "../Factor";

const NewPreset = ({
  children,
  factor,
}: {
  children: any[];
  factor: models.FactorInterface;
}) => {
  return (
    <>
      <div data-tip data-for={factor.id}>
        {children}
      </div>
      <ReactTooltip
        id={factor.id}
        place="right"
        type="light"
        backgroundColor="rgba(0,0,0,0)"
      >
        <Factor readOnly factor={factor} />
      </ReactTooltip>
    </>
  );
};
export default NewPreset;
